export default function useSearch() {
  const onSearch = (value: string, data: any) => {
    if (!!data && !!value) {
      const filteredData = data.map((participant: any) => {
        return {
          ...participant,
          participants: participant?.participants.filter((item: any) => {
            const name =
              item?.user?.full_name ??
              `${item?.user?.first_name ?? item?.firstName} ${
                item?.user?.last_name ?? item?.lastName
              }`;
            return name.toLowerCase().includes(value.toLowerCase());
          }),
        };
      });
      return filteredData;
    } else {
      return data;
    }
  };
  return { onSearch };
}
